import {Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { link } from "fs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";

@Component({
  selector: "sm-todays-bookings",
  templateUrl: "./todays-bookings.component.html",
  styleUrls: ["./todays-bookings.component.scss"],
})
export class TodaysBookingsComponent implements OnInit, OnDestroy {
  repeatArray: any;
  todayCount: any = {};
  todaysBookingData: any = [];
  toshowData: boolean = true;
  loader: boolean = false;
  _apisub: Subscription;
  constructor(
    private _apiservice: ApiService,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService,
    private zone: NgZone
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingStatusUpdate();
    this.listenForMemberBookingAssignmentUpdates();
    this._apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD_COUNT
      ) {
        this.todayCount = {};
        if (resdata.result) {
          this.todayCount = resdata.result;
        }

        this.loader = false
      }
    });
  }

  ngOnInit(): void {
    this.loader = true;
    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
  }
  openAllTodaysBookings() {
    if (this.todayCount?.total_bookings > 0) {
      this.router.navigate(["all-today-bookings"]);
    }
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Today's bookings",
      },
    });
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
          console.log("New notification received in today bookings:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            //check and update for todays bookings only
              // this.loader = true;
              this._apiservice.getTodaysBookingsCountForDashboard("4", "1");

              
            }
          })
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update for todays bookings only
                    // this.loader = true;
                    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
      
                    
                  }
              
          })
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update for todays bookings only
                    // this.loader = true;
                    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
      
                    
                  }
              
          })
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update for todays bookings only
                    // this.loader = true;
                    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
      
                    
                  }
              
          })
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update for todays bookings only
                    // this.loader = true;
                    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
      
                    
                  }
              
          })
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          this.zone.run(() => {
            console.log("New notification received:", payload);
            payload.data.misc =
              typeof payload.data.misc == "string"
                ? JSON.parse(payload.data.misc)
                : payload.data.misc;
                if (true) {
                  //check and update for todays bookings only
                    // this.loader = true;
                    this._apiservice.getTodaysBookingsCountForDashboard("4", "1");
      
                    
                  }
              
          })
        }
      });
  }

  ngOnDestroy(): void {
    this._apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }
}
